export const URL = {
  // dev
  // API_BASE_URL: "http://localhost:7009",
  API_BASE_URL: "https://api.successdream.net",

  signinDeliveryPartner: "/publicApi/signinDeliveryPartner",
  getDeliveryPartnerProfile: "/deliveryPartnerApi/getDeliveryPartnerProfile",
  getAssignedOrderList: "/deliveryPartnerApi/getAssignedOrderList",
  updateAssignmentStatus: "/deliveryPartnerApi/updateAssignmentStatus",
  markAttendanceIn: "/deliveryPartnerApi/markAttendanceIn",
  markAttendanceOut: "/deliveryPartnerApi/markAttendanceOut",
  getAttendanceStatus: "/deliveryPartnerApi/getAttendanceStatus",
};